const Popup = ({ open, setOpen, children, containerClassName, header }) => {
  return (
    <>
      {open && (
        <>
          <div
            className="fixed top-0 left-0 w-full h-full bg-[#00000094] z-[99999]"
            onClick={() => setOpen(false)}
          ></div>
          <div
            className={`fixed min-w-[350px] w-4/5 md:w-1/2 z-[99999] p-5 -translate-x-1/2 -translate-y-1/2 
              bg-mainBg top-1/2 left-1/2 max-h-[80%] overflow-auto rounded-2xl ${containerClassName}`}
          >
            <div className="flex items-center justify-between mb-4">
              <h5 className="text-2xl font-bold text-white capitalize">{header}</h5>
              <span
                onClick={() => setOpen(false)}
                className="text-2xl text-white transition-colors cursor-pointer hover:text-primary"
              >
                ×
              </span>
            </div>
            {children}
          </div>
        </>
      )}
    </>
  );
};

export default Popup;
